import { clsx } from 'clsx'
import styles from './ScoringRulesContent.module.css'

// The single scoring preset ("Nossa Preset"), from core-spec-mvp §2.1.
// Rendered standalone in ScoringRulesSheet and as a section inside LeagueRulesSheet.

type Rule = { event: string; points: string; note?: string }
type Category = { name: string; rules: Rule[] }

const SCORING_CATEGORIES: Category[] = [
  {
    name: 'Participação',
    rules: [
      { event: '1–59 minutos jogados', points: '+1', note: 'Todos os jogadores' },
      { event: '60+ minutos jogados', points: '+2', note: 'Todos · substitui o +1' },
    ],
  },
  {
    name: 'Ataque',
    rules: [
      { event: 'Gol marcado', points: '+7', note: 'Todos' },
      { event: 'Assistência', points: '+4', note: 'Todos' },
      { event: 'Chutes no gol', points: '+1 / 3', note: 'Todos · incremental a cada 3' },
      { event: 'Dribles certos', points: '+1 / 5', note: 'Todos · incremental a cada 5' },
      { event: 'Pênalti sofrido', points: '+3', note: 'Todos' },
      { event: 'Pênalti perdido', points: '−3', note: 'Todos' },
    ],
  },
  {
    name: 'Defesa',
    rules: [
      { event: 'Jogo sem sofrer gol', points: '+5', note: 'GK, DEF · 60+ min jogados' },
      { event: 'Jogo sem sofrer gol', points: '+1', note: 'MID · 60+ min jogados' },
      { event: 'Gols sofridos', points: '−1 / 2', note: 'GK, DEF · incremental a cada 2' },
      { event: 'Contribuição defensiva', points: '+2', note: 'DEF · ≥8 ações (bloqueio + intercep. + duelos)' },
      { event: 'Contribuição defensiva', points: '+2', note: 'MID, ATK · ≥10 ações' },
    ],
  },
  {
    name: 'Goleiro',
    rules: [
      { event: 'Defesa de pênalti', points: '+5', note: 'GK' },
      { event: '3 defesas', points: '+1 / 3', note: 'GK · incremental a cada 3' },
    ],
  },
  {
    name: 'Disciplina',
    rules: [
      { event: 'Cartão amarelo', points: '−1', note: 'Todos' },
      { event: 'Cartão vermelho direto', points: '−3', note: 'Todos' },
      { event: '2 amarelos = vermelho', points: '−3', note: 'Só o vermelho conta · sem −1 adicional' },
      { event: 'Gol contra', points: '−3', note: 'Todos' },
    ],
  },
  {
    name: 'Especial',
    rules: [
      { event: 'Cobrança de pênalti', points: '0', note: 'Nenhum ponto em disputa de pênaltis' },
    ],
  },
]

export function ScoringRulesContent() {
  return (
    <>
      {SCORING_CATEGORIES.map((category) => (
        <div key={category.name} className={styles.category}>
          <h3 className={styles.categoryName}>{category.name}</h3>
          <div className={styles.rulesList}>
            {category.rules.map((rule, idx) => (
              <div key={idx} className={styles.ruleRow}>
                <div className={styles.ruleEvent}>
                  <span className={styles.ruleEventName}>{rule.event}</span>
                  {rule.note && <span className={styles.ruleNote}>{rule.note}</span>}
                </div>
                <span
                  className={clsx(
                    styles.rulePoints,
                    rule.points.startsWith('+') && styles.positive,
                    rule.points.startsWith('−') && styles.negative,
                    rule.points === '0' && styles.neutral,
                  )}
                >
                  {rule.points}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className={styles.footerNote}>
        <p>
          Jogo sem sofrer gol conta apenas em tempo normal + prorrogação.
          Cobranças de pênalti não pontuam. Pontuação do suplente não aplica ao CS.
        </p>
      </div>
    </>
  )
}
